import React from 'react'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import * as S from './ChatFilterNav.styles'

interface Props {
    currentFilter: string
    currentIndex: number
    totalCount: number
    onPrevious: () => void
    onNext: () => void
}

const ChatFilterNav: React.FC<Props> = ({
    currentFilter = 'Less Useful',
    currentIndex = 1,
    totalCount = 10,
    onPrevious,
    onNext,
}) => {
    return (
        <S.Container>
            <S.Text><S.LabelText>{currentFilter} messages:</S.LabelText> {currentIndex} of {totalCount}</S.Text>
            <S.IconsWrapper>
                <S.IconButton onClick={onNext} disabled={currentIndex >= totalCount}>
                    <KeyboardArrowUpIcon />
                </S.IconButton>
                <S.IconButton onClick={onPrevious} disabled={currentIndex <= 1}>
                    <KeyboardArrowDownIcon />
                </S.IconButton>
            </S.IconsWrapper>
        </S.Container>
    )
}

export default ChatFilterNav
